import _ from "lodash";

import AuthUtil from "@/util/AuthUtil";
import { NotificationStore } from "@/stores/NotificationStore";

export default class ApiService {

    static async makeApiCall(endpoint, init, tries = 0) {
        if (tries > 3) {
            NotificationStore.error("Unable to connect to the server. Please try again later.");
            return;
        }

        try {
            const auth = await AuthUtil.getToken(tries > 0);
            const token = _.get(auth, "accessToken");

            if (auth !== undefined && token !== undefined) {
                _.set(init, "headers.Authorization", `Bearer ${token}`);
                const response = await fetch(endpoint, init);

                if (response.status === 401) {
                    return this.makeApiCall(endpoint, init, tries + 1);
                }
                if (response.status >= 500) {
                    NotificationStore.error("Server error. Please try again later.");
                }
                return response;
            } else {
                NotificationStore.error("Authentication failed. Please sign in again.");
            }
        } catch (e) {
            console.error(e);
            if (tries === 0) {
                NotificationStore.error("Network error. Please check your connection.");
            }
        }

    }
}